import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";

const FarmerDetailsForm = (props) => {
  const [date, setDate] = useState("");
  const [backImage, setBackImage] = useState("");
  const [farmerData, setFarmerData] = useState([]);
  const [farmerNo, setFarmerNo] = useState("");
  const [farmerName, setFarmerName] = useState("");
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [ageRange, setAgeRange] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [lga, setLga] = useState("");
  const [address, setAddress] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [villageName, setVillageName] = useState("");
  const [enrollmentPlace, setEnrollmentPlace] = useState("");
  const [farmerEducation, setFarmerEducation] = useState("");
  const [category, setCategory] = useState("");
  const [castReligion, setCastReligion] = useState("");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [seasonNames, setSeasonNames] = useState([]);
  const [seasonId, setSeasonId] = useState("");
  const [plotSize, setPlotSize] = useState("");
  const [bvn, setBvn] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [farmerStatus, setFarmerStatus] = useState("");
  const [idProof, setIdProof] = useState("");
  const [idProofUrl, setIdProofUrl] = useState("");
  const [signature, setSignature] = useState("");

  const formatDate = (date) => {
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`; // returns the date in YYYY-MM-DD format
  };

  const nigerianStates = [
    "Abia",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
  ];
  const educationLevels = [
    "No Formal Education",
    "Primary Education",
    "Secondary Education",
    "Bachelor Degree",
    "Master Degree",
    "Quranic School",
    "Tertiary",
    "Post Graduate",
    "HSC",
    "SSC",
  ];

  const farmerStatusOptions = [
    "New farmers",
    "New Non sponsored",
    "New sponsored",
    "Old farmers",
    "Old Non sponsored",
    "Old sponsored",
    "Old with BF sponsored",
    "Old with BF Non sponsored",
    "Dormant loans",
  ];
  const maritalStatusOptions = ["Single", "Married", "Divorced", "Widowed"];
  const castReligionOptions = ["Christianity", "Islam"];

  const categoryList = [
    "Demo Farmer",
    "Maize Outgrower",
    "Outgrower",
    "Research Plot",
    "Seed Production",
    "Soya Outgrower",
  ];

  const plotSizeOptions = [
    "0.5",
    "1",
    "1.5",
    "2",
    "2.5",
    "3",
    "3.5",
    "4",
    "4.5",
    "5",
    "5.5",
    "6",
    "6.5",
    "7",
    "7.5",
    "8",
    "8.5",
    "9",
    "9.5",
    "10",
    "10.5",
    "11",
    "11.5",
    "12",
  ];

  const { sendRequest: getSeasonData } = useHttp();

  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setSeasonNames(res);
        }
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getFarmerData } = useHttp();

  useEffect(() => {
    if (props.update) {
      //   console.log(props.update);

      const Id = props.update.farmerId || 0;

      getFarmerData(
        {
          url: `/api/farmerDetailViewList/?orgId=${localStorage.getItem(
            "orgId"
          )}&farmerId=${Id}`,
        },
        (res) => {
          if (res) {
            console.log(res);
            setFarmerData(res);
            const formattedDate = res.registrationDate
              ? formatDate(res.registrationDate)
              : "";
            setDate(formattedDate);
            setFarmerNo(res.farmerNo || "");
            setFarmerName(res.farmerName || "");
            setGender(res.gender || "");
            const fDob = res.dob ? formatDate(res.dob) : "";

            setDob(fDob);
            setAgeRange(res.ageRange || "");
            setEmail(res.email || "");
            setMobileNo(res.mobile || "");
            setLga(res.lga || "");
            setAddress(res.address || "");
            setCountry(res.country || "");
            setState(res.state || "");
            setCity(res.city || "");
            setVillageName(res.villageName || "");
            setEnrollmentPlace(res.enrollmentPlace || "");
            setFarmerEducation(res.farmerEducation || "");
            setCategory(res.category || "");
            setCastReligion(res.religion || "");
            setMaritalStatus(res.maritalStatus || "");
            setSeasonId(res.seasonId || "");
            setPlotSize(res.plotSizeInHa || "");
            setBvn(res.bvn || "");
            setBankName(res.bankName || "");
            setAccountNumber(res.accountNumber || "");
            setAccountHolderName(res.accountHolderName || "");
            setFarmerStatus(res.farmerStatus || "");
            setIdProof(res.idProof || "");
            setIdProofUrl(res.urlAttachment || "");
            setSignature(res.signatureAttachment || "");
            setBackImage(`${res.urlProfile || ""}`);
          }
        }
      );
    }
  }, [props.update]);

  const { sendRequest: putFarmer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);

    var data = "";
    if (props.update) {
      data = {
        registrationDate:moment(date).format("DD/MM/YYYY"),
        farmerId: farmerData?.farmerId || 0,
        farmerNo: farmerNo,
        farmerName: farmerName,
        gender: gender,
        dob: moment(dob).format("DD/MM/YYYY"),
        ageRange: ageRange,
        mobile: mobileNo,
        email: email,
        lga: lga,
        address: address,
        city: city,
        state: state,
        country: country,
        villageName: villageName,
        enrollmentPlace: enrollmentPlace,
        farmerEducation: farmerEducation,
        category: category,
        religion: castReligion,
        maritalStatus: maritalStatus,
        seasonId: seasonId,
        plotSizeInHa: plotSize,
        bvn: bvn,
        bankName: bankName,
        accountNumber: accountNumber,
        accountHolderName: accountHolderName,
        idProof: idProof,
        urlProfile: backImage,
        urlAttachment: idProofUrl,
        signatureAttachment: signature,
        createdBy: farmerData?.createdBy,
        fieldExecutiveId: farmerData?.fieldExecutiveId,
        regionId: farmerData?.regionId,
        empId: farmerData?.empId,
      };

      console.log(data);

      putFarmer(
        {
          url: "/api/farmerEnrolment/",
          method: "PUT",
          body: data,
        },
        (data) => {
          toast.success(`Farmer Updated successfully`);
          props.addForm(false);
        }
      );
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Farmer Enrolment Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div class="profile-upload-container">
                        <div class="profile-image">
                          <img
                           // src={backImage}
                            src={`${process.env.REACT_APP_FILE_URL}${backImage}`}
                            id="profileImage"
                            class="img-circle"
                            alt="Profile Image"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Registration Date</label>
                            <input
                              type="date"
                              className="form-control"
                              value={date}
                              onChange={(e) => setDate(e.target.value)}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Farmer No</label>
                            <input
                              type="text"
                              className="form-control"
                              value={farmerNo}
                              onChange={(e) => setFarmerNo(e.target.value)}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Farmer Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={farmerName}
                              onChange={(e) => setFarmerName(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* /.col */}

                    <div className="col-md-3"></div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Gender</label>
                        <select
                          className="form-control"
                          value={gender}
                          onChange={(e) => setGender(e.target.value)}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Date of Birth</label>
                        <input
                          type="date"
                          className="form-control"
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Age Range</label>

                        <select
                          id="address_type"
                          className="form-control"
                          value={ageRange}
                          onChange={(e) => setAgeRange(e.target.value)}
                        >
                          <option value="">Select</option>
                          <option value="18-39">18-39</option>
                          <option value="40 Above">40 Above</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="optional"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Mobile No</label>
                        <input
                          type="number"
                          className="form-control"
                          value={mobileNo}
                          onChange={(e) => setMobileNo(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>LGA</label>

                        <input
                          type="text"
                          className="form-control"
                          value={lga}
                          onChange={(e) => setLga(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Address</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="optional"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Country</label>
                        <select
                          id="address_type"
                          className="form-control"
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                        >
                          <option value="Nigeria">Nigeria</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>State</label>

                        <select
                          id="address_type"
                          className="form-control"
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                        >
                          <option value="">Select</option>
                          {nigerianStates.map((state, index) => (
                            <option key={index} value={state}>
                              {state}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>City</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Village Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder=""
                          value={villageName}
                          onChange={(e) => setVillageName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Enrollment Place</label>

                        <select
                          id="address_type"
                          className="form-control"
                          value={enrollmentPlace}
                          onChange={(e) => setEnrollmentPlace(e.target.value)}
                        >
                          <option value="">Select</option>
                          <option value="On the Field">On the Field</option>
                          <option value="Off the Field">Off the Field</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {" "}
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer Eduction</label>

                        <select
                          id="address_type"
                          className="form-control"
                          value={farmerEducation}
                          onChange={(e) => setFarmerEducation(e.target.value)}
                        >
                          <option value="">Select</option>
                          {educationLevels.map((level, index) => (
                            <option key={index} value={level}>
                              {level}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Category</label>

                        <select
                          id="address_type"
                          className="form-control"
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                        >
                          <option value="">Select</option>
                          {categoryList.map((cat, index) => (
                            <option key={index} value={cat}>
                              {cat}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Cast/Religion</label>
                        <select
                          className="form-control"
                          value={castReligion}
                          onChange={(e) => setCastReligion(e.target.value)}
                        >
                          <option value="">Select</option>
                          {castReligionOptions.map((religion, index) => (
                            <option key={index} value={religion}>
                              {religion}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Marital Status</label>
                        <select
                          className="form-control"
                          value={maritalStatus}
                          onChange={(e) => setMaritalStatus(e.target.value)}
                        >
                          <option value="">Select</option>
                          {maritalStatusOptions.map((status, index) => (
                            <option key={index} value={status}>
                              {status}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Season Name</label>
                        <select
                          className="form-control"
                          value={seasonId}
                          onChange={(e) => setSeasonId(e.target.value)}
                        >
                          <option value="0">Select</option>
                          {seasonNames &&
                            seasonNames.map((season, index) => (
                              <option key={index} value={season.seasonId}>
                                {season.seasonName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label htmlFor="plotSize">Plot Size</label>
                        <select
                          id="plotSize"
                          className="form-control"
                          value={plotSize}
                          onChange={(e) => setPlotSize(e.target.value)}
                        >
                          <option value="">Select Plot Size</option>
                          {plotSizeOptions.map((size, index) => (
                            <option key={index} value={size}>
                              {size}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>BVN</label>
                        <input
                          type="text"
                          className="form-control"
                          value={bvn}
                          onChange={(e) => setBvn(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Bank Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={bankName}
                          onChange={(e) => setBankName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={accountNumber}
                          onChange={(e) => setAccountNumber(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Account Holder Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={accountHolderName}
                          onChange={(e) => setAccountHolderName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Farmer Status</label>
                        <select
                          className="form-control"
                          value={farmerStatus}
                          onChange={(e) => setFarmerStatus(e.target.value)}
                        >
                          <option value="">Select</option>
                          {farmerStatusOptions.map((status, index) => (
                            <option key={index} value={status}>
                              {status}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>ID Proof</label>
                        <input
                          type="text"
                          className="form-control"
                          value={idProof}
                          readOnly
                          onChange={(e) => setIdProof(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>ID Proof</label>
                        <br />
                        <img
                          src={`${process.env.REACT_APP_FILE_URL}${idProofUrl}`}
                          className="user-image"
                          alt=" image"
                          height="100"
                          width="100"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <label>Signature</label>
                      <br />
                      <img
                        src={`${process.env.REACT_APP_FILE_URL}${signature}`}
                        className="user-image"
                        alt=" sign"
                        height="100"
                        width="100"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default FarmerDetailsForm;
